export const story1 = `
{{We[[1,x,x]]}} have little time to communicate.
{{The warden is approaching[[x,30,x]]}} you{{r[[x,70,x]]}} {{ship[[70,x,x]]}}. He {{may[[20,x,x]]}} already be in yo{{u[[x,70,x]]}}r mi{{n[[x,70,x]]}}d.
Do not {{trust[[1,x,x]]}} him to speak to you.
Don't ev{{en trust[[30,x,x]]}} {{you[[1,x,x]]}}rself or the contents this message.
T{{h[[x,80,1]]<<Cloaking Device>>}}ere are th{{i[[x,80,1]]<<Cloaking Device>>}}ngs at play that {{are[[1,x,x]]}} beyon{{d[[x,80,1]]<<Cloaking Device>>}} {{your[[60,x,x]]}} und{{e[[x,80,1]]<<Cloaking Device>>}}rstanding or {{control[[80,1,x]]<<Ship Controls>>}}.
Let {{us[[40,x,x]]}} know how {{well[[1,x,x]]}} {{you[[10,x,x]]}} fare.

We send this {{with[[50,x,x]]}} hope you {{stay safe[[x,x,100]]<$Story1$>}}.
Transmitted from Cordant Prime
----------
{{Acknowledge?[[1,x,x]]<<Communication Device>>}}
`;
